import { trialNotificationPreferencesService } from '@/services/trial-notification-preferences-service'
import { denormalize, normalize } from 'normalizr'
import { schemas } from '@/store/schemas'
import _ from 'lodash'

export const mutations = {
  ['SET_TRIAL_NOTIFICATION_PREFERENCES'](state, preferences) {
    if (!_.isNil(preferences)) {
      const result = normalize(preferences, schemas.trialNotificationPreferencesList)
      state.trialNotificationPreferences = result.entities.trialNotificationPreferences
    }
  },
  ['MERGE_TRIAL_NOTIFICATION_PREFERENCES'](state, preferences) {
    if (!_.isNil(preferences)) {
      const result = normalize(preferences, schemas.trialNotificationPreferences)
      state.trialNotificationPreferences = _.merge(
        {},
        state.trialNotificationPreferences,
        result.entities.trialNotificationPreferences
      )
    }
  }
}

export const actions = {
  async ['GET_TRIAL_NOTIFICATION_PREFERENCES']({ commit }) {
    const response = await trialNotificationPreferencesService.get()
    if (!_.isNil(response)) {
      commit('SET_TRIAL_NOTIFICATION_PREFERENCES', response.data)
    }
  },
  async ['CREATE_TRIAL_NOTIFICATION_PREFERENCES']({ commit }, { trialNotificationPreferences }) {
    const response = await trialNotificationPreferencesService.create(trialNotificationPreferences)
    if (!_.isNil(response)) {
      commit('MERGE_TRIAL_NOTIFICATION_PREFERENCES', response.data)
    }
  },
  async ['UPDATE_TRIAL_NOTIFICATION_PREFERENCES']({ commit }, { trialNotificationPreferences }) {
    const response = await trialNotificationPreferencesService.update(trialNotificationPreferences)
    if (!_.isNil(response)) {
      commit('MERGE_TRIAL_NOTIFICATION_PREFERENCES', response.data)
    }
  }
}

export const getters = {
  trialNotificationPreferencesByTrialId: (state, getters) => trialId => {
    const preferences = _.find(state.trialNotificationPreferences, { trial: trialId })
    if (_.isNil(preferences)) {
      return null
    }
    return denormalize(
      preferences.id,
      schemas.trialNotificationPreferences,
      getters.getNormalizedState()
    )
  }
}
